import {NgModule} from "@angular/core";
import {CommonModule, CurrencyPipe} from "@angular/common";
import {TextFieldComponent} from "./components/text-field/text-field.component";
import {ImageFieldComponent} from "./components/image-field/image-field.component";
import {FileFieldComponent} from "./components/file-field/file-field.component";
import {NumberFieldComponent} from "./components/number-field/number-field.component";
import {DocumentsComponent} from "./components/documents/documents.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormFieldWrapperComponent} from "./components/form-field-wrapper/form-field-wrapper.component";
import {CheckboxFieldComponent} from "./components/checkbox-field/checkbox-field.component";
import {RadioFieldComponent} from "./components/radio-field/radio-field.component";
import {DropdownFieldComponent} from "./components/dropdown-field/dropdown-field.component";
import {OrderByPipe} from "./pipes/order-by.pipe";
import {RemoveEmptyKeyPipe} from "./pipes/remove-empty-key.pipe";
import {CleanElementSelectorPipe} from "./pipes/clean-element-selector.pipe";
import {DateFieldComponent} from "./components/date-field/date-field.component";
import {KeywordPipe} from "./pipes/keyword.pipe";
import {IsGlobalPipe} from "./pipes/is-global.pipe";
import {RemoveHtmlEntitiesPipe} from "./pipes/remove-html-entities.pipe";
import {AnswerDisplayPipe} from "./pipes/answer-display.pipe";
import {KExplorerPipe} from "./pipes/kexplorer-file-viewer.pipe";
import {SearchFieldComponent} from "./components/search-field/search-field.component";
import {TaxpayerListComponent} from "./components/taxpayer-list/taxpayer-list.component";
import {TaxReturnListItemComponent} from "./components/taxpayer-list/tax-return-list-item/tax-return-list-item.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { MatSelectModule } from "@angular/material/select";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import {RouterModule} from "@angular/router";
import {StatusBadgeComponent} from "./components/status-badge/status-badge.component";
import {TaxReturnActionsComponent} from "./components/tax-return-actions/tax-return-actions.component";
import {GlobalAnswerComponent} from "../app/clients/client/populations/population-rules/global-answer/global-answer.component";
import {TextAreaComponent} from "./components/text-area/text-area.component";
import {SearchDropdownComponent} from "./components/search-dropdown/search-dropdown.component";
import {TaxYearsService} from "./util/tax-years.service";
import { TaxReturnTypeSubTypeService } from "./util/tax-return-type-subtype.service";
import { NotesComponent } from "./components/notes/notes.component";
import { HelpPopupComponent } from "./components/help-popup/help-popup.component";
import { CommentComponent } from "../app/tax-returns/tax-return/comment/comment.component";
import { TooltipDirective } from "./directives/tooltip/tooltip.directive";
import { ReviseConfirmationComponent } from "./components/tax-return-actions/revise-confirmation/revise-confirmation.component";
import { AmendConfirmationComponent } from "./components/tax-return-actions/amend-confirmation/amend-confirmation.component";
import { ChangeReasonComponent } from "./components/tax-return-actions/change-reason/change-reason.component";
import { RejectConfirmationComponent } from "./components/tax-return-actions/reject-confirmation/reject-confirmation.component";
import { TaxreturnApprovalConfirmationComponent } from "./components/tax-return-actions/approval-confirmation/approval-confirmation.component";
import { PreviewFinalPackageComponent } from "./components/tax-return-actions/preview-final-package/preview-final-package.component";
import { TenantConfigService } from "./services/tenant-config.service";
import { TemplateGenerationSelectionComponent } from "./components/tax-return-actions/template-generation-selection/template-generation-selection.component";
import { NumberOrdinalPipe } from "./pipes/number-ordinal.pipe";
import { BulkProcessNoQnrComponent } from "./components/tax-return-actions/bulk-process-no-qnr/bulk-process-no-qnr.component";
import { TaxReturnBulkActionsComponent } from "./components/taxpayer-list/tax-return-bulk-actions/tax-return-bulk-actions.component";
import { BulkStatusUpdateComponent } from "./components/taxpayer-list/tax-return-bulk-actions/bulk-status-update/bulk-status-update.component";
import { BulkMoveAssigneesComponent } from "./components/taxpayer-list/tax-return-bulk-actions/bulk-move-assignees/bulk-move-assignees.component";
import { BulkGeneratePackage } from "./components/taxpayer-list/tax-return-bulk-actions/bulk-generate-package/bulk-generate-package.component";
import { SchedulePackageGeneration } from "./components/taxpayer-list/tax-return-bulk-actions/schedule-package-generation/schedule-package-generation.component";
import { BatchGeneratePackage } from "./components/taxpayer-list/tax-return-bulk-actions/batch-generate-package/batch-generate-package.component";
import { CreateBatch } from "./components/taxpayer-list/tax-return-bulk-actions/create-batch/create-batch.component";
import { AddToBatch } from "./components/taxpayer-list/tax-return-bulk-actions/add-to-batch/add-to-batch.component";
import { RemoveFromBatch } from "./components/taxpayer-list/tax-return-bulk-actions/remove-from-batch/remove-from-batch.component";
import { ProcessStatePollingService } from "./services/process-state-polling.service";
import { BulkUpdateTaxReturnService } from "./services/bulk-update-tax-return.service";
import { BulkProcessStatePollingService } from "./services/bulk-process-state-polling.service";
import { CurrentBatchService } from "./services/current-batch.service";
import { BatchSendPackage } from "./components/taxpayer-list/tax-return-bulk-actions/batch-send-package/batch-send-package.component";
import { LocalStorageTimerService } from "./services/local-storage-timer.service";
import { BaseURLService } from "./util/baseUrl.service";
import {TemplateTypePipe} from "./pipes/template-type.pipe";
import { TranslocoRootModule } from './../app/transloco-root.module';
import { RunCalcsService } from "./services/run-calcs.service";
import { AttachmentsComponent } from "../app/tax-returns/tax-return/subcategory/comments/attachments/attachments.component";
import { DialogTitleComponent } from "./components/dialog-title/dialog-title.component";
import { VirtualScrollerComponent } from "./virtual-scrolling/virtual-scroller.component";


@NgModule({
  imports: [
    MatDialogModule,
    MatSelectModule,
    MatMenuModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule,
    TranslocoRootModule,
    DialogTitleComponent,
    VirtualScrollerComponent,
  ],
  exports: [
    TextFieldComponent,
    ImageFieldComponent,
    FileFieldComponent,
    TextAreaComponent,
    NumberFieldComponent,
    CheckboxFieldComponent,
    DocumentsComponent,
    FormFieldWrapperComponent,
    RadioFieldComponent,
    DropdownFieldComponent,
    CleanElementSelectorPipe,
    OrderByPipe,
    RemoveEmptyKeyPipe,
    DateFieldComponent,
    RadioFieldComponent,
    SearchFieldComponent,
    KeywordPipe,
    IsGlobalPipe,
    RemoveHtmlEntitiesPipe,
    AnswerDisplayPipe,
    KExplorerPipe,
    TemplateTypePipe,
    TaxpayerListComponent,
    StatusBadgeComponent,
    TaxReturnActionsComponent,
    SearchDropdownComponent,
    NotesComponent,
    CommentComponent,
    HelpPopupComponent,
    TooltipDirective,
    TemplateGenerationSelectionComponent,
    BulkProcessNoQnrComponent,
    AttachmentsComponent,
  ],
  declarations: [
    TemplateGenerationSelectionComponent,
    TextFieldComponent,
    ImageFieldComponent,
    FileFieldComponent,
    TextAreaComponent,
    NumberFieldComponent,
    CheckboxFieldComponent,
    DocumentsComponent,
    FormFieldWrapperComponent,
    RadioFieldComponent,
    DropdownFieldComponent,
    CleanElementSelectorPipe,
    OrderByPipe,
    RemoveEmptyKeyPipe,
    RadioFieldComponent,
    DateFieldComponent,
    SearchFieldComponent,
    KeywordPipe,
    IsGlobalPipe,
    RemoveHtmlEntitiesPipe,
    AnswerDisplayPipe,
    KExplorerPipe,
    TemplateTypePipe,
    TaxpayerListComponent,
    TaxReturnListItemComponent,
    StatusBadgeComponent,
    TaxReturnActionsComponent,
    GlobalAnswerComponent,
    SearchDropdownComponent,
    NotesComponent,
    CommentComponent,
    HelpPopupComponent,
    TooltipDirective,
    AmendConfirmationComponent,
    ReviseConfirmationComponent,
    ChangeReasonComponent,
    RejectConfirmationComponent,
    TaxreturnApprovalConfirmationComponent,
    PreviewFinalPackageComponent,
    NumberOrdinalPipe,
    BulkProcessNoQnrComponent,
    TaxReturnBulkActionsComponent,
    BulkStatusUpdateComponent,
    BulkMoveAssigneesComponent,
    CreateBatch,
    AddToBatch,
    RemoveFromBatch,
    BulkGeneratePackage,
    BatchGeneratePackage,
    BatchSendPackage,
    SchedulePackageGeneration,
    AttachmentsComponent,
  ],
  providers: [
    CurrencyPipe, TaxYearsService, TaxReturnTypeSubTypeService, TenantConfigService,
    ProcessStatePollingService, BulkUpdateTaxReturnService, BulkProcessStatePollingService,
    CurrentBatchService, LocalStorageTimerService, BaseURLService, RunCalcsService],
})
export class SharedModule {
}
